import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Public branded base URL for agency recruitment pages.
// Always uses the iEvntür custom domain — NEVER the Emergent preview URL —
// because recruitment URLs are public-facing marketing assets.
// Falls back to REACT_APP_PUBLIC_AGENCY_BASE_URL → REACT_APP_BACKEND_URL only in non-prod safety net.
export const PUBLIC_AGENCY_BASE_URL =
  process.env.REACT_APP_PUBLIC_AGENCY_BASE_URL || "https://app.ievntur.com";

export function agencyPublicUrl(slug) {
  if (!slug) return PUBLIC_AGENCY_BASE_URL;
  return `${PUBLIC_AGENCY_BASE_URL.replace(/\/$/, "")}/agency/${slug}`;
}

